import React from "react";
import { Button } from "react-bootstrap";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiInput } from "../../../components/form/UiInput";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";

export const AddTeamMembership = () => {
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" >
                    <div className="sb-add-team-membership">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="12">
                                    <h3>Add Team Members</h3>
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco. </p>
                                </UiCol>
                                <UiCol lg="6">
                                    <div className="sb-add-team-membership__sb-gift-input-card">
                                        <UiInput
                                            placeholder="Enter members’ email here"
                                            type="email" />
                                        <Button >Invite </Button>
                                    </div>
                                </UiCol>
                            </UiSingleRow>

                        </UiContentCol>
                    </div>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}